import React from 'react';
import { MarketingShell, CONTACT_EMAIL, IMG } from './LandingPage';

const PLANS = [
  {
    name: 'Basic Plan',
    price: 'Nu. 2,500',
    text: 'POS, inventory, and Bhutan GST for a single shop. Ideal when you are ready to leave notebooks behind.',
    recommended: false,
  },
  {
    name: 'Standard Plan',
    price: 'Nu. 4,200',
    text: 'Adds vendors, purchase orders, and sales reports — for growing shops that need full daily control.',
    recommended: true,
  },
  {
    name: 'Premium Plan',
    price: 'Nu. 6,800',
    text: 'Every feature plus multi-branch and priority support — for chains and multi-location retailers.',
    recommended: false,
  },
];

const STORIES = [
  {
    title: 'Dzongkha Boutique',
    text: 'One login for every outlet. Stock and sales stay aligned — managers finally see the whole business.',
    img: IMG.quote1,
  },
  {
    title: 'Thimphu Electronics',
    text: 'Inventory became accurate. Fewer “out of stock” surprises, happier customers, clearer sales in Nu.',
    img: IMG.quote2,
  },
  {
    title: 'Pema Department Store',
    text: 'Faster checkout with POS and Bhutan GST ready when auditors ask — less stress, more selling time.',
    img: IMG.quote3,
  },
];

const SolutionsPage: React.FC = () => (
  <MarketingShell
    title="Solutions - NAC Easy Solution"
    description="POS, inventory, purchasing, and Bhutan GST for Bhutanese shops — priced in Nu. Register your shop today."
  >
    <section className="sk-page-hero" style={{ backgroundImage: `url(${IMG.hero})` }}>
      <div>
        <h1>The system shop owners use to run the day</h1>
        <p>Sell at the till, know your stock, buy from vendors, and stay GST-ready — all in Nu., made for Bhutan.</p>
      </div>
    </section>

    <section className="sk-section">
      <div className="sk-section-head">
        <h2>What you get from day one</h2>
        <p>Clear tools your staff can learn quickly — so customers leave happy and you trust the numbers.</p>
      </div>
      <div className="sk-grid-4">
        <article className="sk-card">
          <div className="sk-card-img" style={{ backgroundImage: `url(${IMG.pos})` }} />
          <h3>Point of Sale (POS)</h3>
          <p>Check out in Nu. with cash, card, or mobile pay. Split payments, credit sales, and print receipts fast.</p>
        </article>
        <article className="sk-card">
          <div className="sk-card-img" style={{ backgroundImage: `url(${IMG.inventory})` }} />
          <h3>Inventory &amp; Products</h3>
          <p>Products, barcodes, Nu. prices, GST type, and stock on hand — updated when you sell or receive.</p>
        </article>
        <article className="sk-card">
          <div className="sk-card-img" style={{ backgroundImage: `url(${IMG.purchase})` }} />
          <h3>Purchase Orders &amp; Goods Receipt</h3>
          <p>Order from vendors, track what is still due, and raise stock only when goods arrive.</p>
        </article>
        <article className="sk-card">
          <div className="sk-card-img" style={{ backgroundImage: `url(${IMG.sales})` }} />
          <h3>Sales Reports &amp; Bhutan GST</h3>
          <p>See what sold and stay ready for GST — tax invoice with a TPN, or a normal receipt without one.</p>
        </article>
      </div>
    </section>

    <section className="sk-section sk-quotes">
      <div className="sk-section-head">
        <h2>Plans that fit your shop</h2>
        <p>Start small or go multi-branch. Prices in Nu. — pick what matches how you sell today.</p>
      </div>
      <div className="sk-price-grid">
        {PLANS.map((plan) => (
          <article key={plan.name} className={`sk-price${plan.recommended ? ' recommended' : ''}`}>
            {plan.recommended && <p>Recommended</p>}
            <h3>{plan.name}</h3>
            <p className="sk-amount">{plan.price}</p>
            <p>{plan.text}</p>
            <a className="sk-btn" href={`mailto:${CONTACT_EMAIL}?subject=${encodeURIComponent(`I want the ${plan.name}`)}`}>Select plan</a>
          </article>
        ))}
      </div>
    </section>

    <section className="sk-section">
      <div className="sk-section-head">
        <h2>Shops across Bhutan already run on it</h2>
        <p>From boutiques to electronics counters — owners choose NAC Easy Solution to sell, stock, and report with confidence.</p>
      </div>
      <div className="sk-grid-3">
        {STORIES.map((story) => (
          <article key={story.title} className="sk-card">
            <div className="sk-card-img" style={{ backgroundImage: `url(${story.img})` }} />
            <h3>{story.title}</h3>
            <p>{story.text}</p>
          </article>
        ))}
      </div>
    </section>

    <section className="sk-cta-band">
      <div className="sk-cta-band-inner">
        <h2>Ready to put your shop on NAC Easy Solution?</h2>
        <p>Email us your shop name, how many branches you have, and your TPN if you have one. We will help you get started.</p>
        <a
          className="sk-btn"
          href={`mailto:${CONTACT_EMAIL}?subject=${encodeURIComponent('Register my shop — NAC Easy Solution')}`}
        >
          Register your shop
        </a>
      </div>
    </section>
  </MarketingShell>
);

export default SolutionsPage;
